import { render, staticRenderFns } from "./MainVideoInfo.vue?vue&type=template&id=19c454ac&scoped=true&"
import script from "./MainVideoInfo.vue?vue&type=script&lang=ts&"
export * from "./MainVideoInfo.vue?vue&type=script&lang=ts&"
import style0 from "./MainVideoInfo.vue?vue&type=style&index=0&id=19c454ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c454ac",
  null
  
)

export default component.exports